<template>
    <div class="container fourth">
        <div class="row">
            <div class="col-8">
                <div class="headline h2">
                    <span>Wie erreichen wir Dich?</span>
                </div>

                <div class="row">
                    <div class="input-group col-6">
                        <input v-model="forename" :name="'forename'" placeholder="Vorname" v-validate="'required'">
                    </div>
                    <div class="input-group col-6">
                        <input v-model="lastname" :name="'lastname'" placeholder="Nachname" v-validate="'required'">
                    </div>
                    <div class="input-group col-6">
                        <datetime v-model="gebdate" :name="'gebdate'" :title="'Geburtsdatum'" :minute-step="15" type="datetime" :flow="['year','date']" :auto="true"
                                  :max-datetime="maxDateTime" placeholder="Geburtsdatum" v-validate="'required'" :format="'dd.LL.y'"
                                  :phrases="{ok: 'Ok', cancel: 'Abbrechen'}"
                                  v-bind:class="{'error':(showErrors && gebdate=='')}"></datetime>
                        <br>
                    </div>
                    <div class="input-group col-10">
                        <input v-model="street" :name="'street'" placeholder="Straße" v-validate="'required'">
                    </div>
                    <div class="input-group col-2">
                        <input v-model="streetnr" :name="'streetnr'" placeholder="Nr." v-validate="'required'">
                    </div>
                    <div class="input-group col-3">
                        <input v-model="zip" :name="'zip'" placeholder="PLZ" v-validate="'required'">
                    </div>
                    <div class="input-group col-9">
                        <input v-model="town" :name="'town'" placeholder="Ort" v-validate="'required'">
                        <br><br>
                    </div>
                    <div class="input-group col-6">
                        <input v-model="phone" :name="'phone'" placeholder="Telefonnummer" v-validate="'required'">
                    </div>
                    <div class="input-group col-6">
                        <input v-model="mail" :name="'mail'" placeholder="E-Mail Adresse" v-validate="'required|email'">
                    </div>
                </div>
            </div>
            <div class="col-4 icon-master">
                <i class="fa fa-phone"></i>
            </div>

        </div>
    </div>

</template>

<script>
    import {Datetime} from 'vue-datetime'


    export default {
        name: 'fourthStep',
        components: {
            datetime: Datetime
        },

        data: function () {
            return {
                showErrors: false,
                forename: '',
                lastname: '',
                gebdate: '',
                street: '',
                streetnr: '',
                zip: '',
                town: '',
                phone: '',
                mail: '',

                maxDateTime: new Date(new Date().setFullYear(new Date().getFullYear() - 15)).toISOString(),
            }
        },

        mounted() {

        },

        methods: {
            nextPage() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Success
                        this.$emit('openNextPage', this);
                        return;
                    }
                    if (!result) {
                        // Error
                        this.showErrors = true;
                        console.log(this);
                    }
                });
            }
        }
    }
</script>

<style lang="less">
.vdatetime.error {
    input {
        border-color: #AB0000;
    }
}
div.vdatetime-popup__actions__button, div.vdatetime-time-picker__item--selected, div.vdatetime-month-picker__item--selected, div.vdatetime-year-picker__item--selected {
  color: #4d9aa2;
}
div.vdatetime-popup__header, div.vdatetime-calendar__month__day--selected > span > span, div.vdatetime-calendar__month__day--selected:hover > span > span {
  background: #4d9aa2;
}
.vdatetime-popup__body {
  overflow: auto;
  max-height: 55vh;
}
</style>